// extracted by mini-css-extract-plugin
export var logo = "freshers2018-module--logo--ZoLaJ";
export var jumbotronBackground = "freshers2018-module--jumbotronBackground--3WA88";